import React, { useEffect, useState } from 'react';
import { Button } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import { PageLayout } from '../../../../../components/generics/PageLayout';
import { TableServicesIa } from './components/TableServicesIa';
import { BannerInfoServicesIa } from './components/BannerInfoServicesIa';
import { hasPemissions } from '../../../../../commons/utils';
import { IServicesIa } from './interfaces/IServicesIaFrontend';

import { Link } from 'react-router-dom';

export const ServiciosIa = () => {
  const [canCreate, setCanCreate] = useState(false);
  const [openCreate, setOpenCreate] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [itemToEdit, setItemToEdit] = useState<IServicesIa | null>(null);

  useEffect(() => {
    canCheckCanCreate();
  }, []);

  const canCheckCanCreate = async () => {
    const havePermissions = await hasPemissions('modulo.manager', 'modulo.manager.plataforma.ia', 'create', 'modulo.manager.plataforma.ia.configuracion', 'modulo.manager.plataforma.ia.configuracion.servicios');
    setCanCreate(havePermissions);
  }

 
  return (
    <PageLayout
      title="Configuración de Servicios IA"
      mainModule="Manager"
      icon="SmartToy"
      infoAlert="Administración general de los modelos de Inteligencia Artificial."
      actionButtons={
        <>
          {canCreate && (
         
            <Button 
              variant="contained" 
              color="primary" 
              startIcon={<AddIcon />} 
              component={Link}
              to={'/manager/plataforma-ia/configuracion/servicios/crear'}
              sx={{
                borderRadius: 2,
                px: 3,
                py: 1,
                fontWeight: 600,
                textTransform: 'none',
                boxShadow: '0px 4px 8px -4px rgba(105, 108, 255, 0.42)'
              }}
            >
              Crear Servicio IA
            </Button>
          )}
        </>
      }
    >
      

      <TableServicesIa/>


      <BannerInfoServicesIa />
      
    </PageLayout>
  )
}
